// Libs
import classNames from 'classnames/bind';
import { Grid2, IconButton } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
import { BaseInput, BaseSelect } from '~/components/common';
// Others
import { IBaseOption } from '~/utils/interface/common';
import { DEFAULT_NUMBER_ZERO, EMPTY_STRING, REG_EXP } from '~/utils/constants/common';
import { IFormJob } from '~/utils/interface/job';
import { mockDateDiscountJob } from '~/utils/mockData/job';
// Styles, images, icons
import styles from './DiscountJob.module.scss';
import { icons } from '~/assets';

type Props = {
  index: number;
  onRemoveItem: (index: number) => void;
};

const cx = classNames.bind(styles);

const DiscountJob = (props: Props) => {
  //#region Destructuring Props
  const { index, onRemoveItem } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/job']);

  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext<IFormJob>();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Grid2
      component='div'
      id='discountsComponent'
      className={cx('container')}
      container
      rowSpacing={'12px'}
      columnSpacing={'12px'}
    >
      <Grid2
        size={'grow'}
        container
        rowSpacing={'12px'}
        columnSpacing={'12px'}
        className={cx(index !== DEFAULT_NUMBER_ZERO ? 'item' : EMPTY_STRING)}
      >
        <Grid2 size={'grow'}>
          <Controller
            name={`discounts.${index}.description`}
            control={control}
            render={({ field: { value, onChange } }) => (
              <BaseInput
                label={t('field_discount_description_label')}
                value={value}
                onChange={onChange}
                errorMessage={errors?.discounts?.[index]?.description?.message}
              />
            )}
          />
        </Grid2>

        <Grid2 size={'grow'}>
          <Controller
            name={`discounts.${index}.type`}
            control={control}
            render={({ field: { value, onChange } }) => (
              <BaseSelect
                label={t('field_discount_type_label')}
                value={value || EMPTY_STRING}
                onChange={({ value: optionValue }: IBaseOption) =>
                  onChange(optionValue, { shouldValidate: true, shouldDirty: true })
                }
                options={mockDateDiscountJob}
                required
                errorMessage={
                  typeof errors?.discounts?.[index]?.type === 'object'
                    ? errors?.discounts?.[index]?.type?.message
                    : EMPTY_STRING
                }
              />
            )}
          />
        </Grid2>

        <Grid2 size={'grow'}>
          <Controller
            name={`discounts.${index}.rate`}
            control={control}
            render={({ field: { value, onChange } }) => (
              <BaseInput
                label={t('field_discount_rate_label')}
                value={value}
                required
                onChange={(event) => {
                  const inputValue = event.target.value.replace(REG_EXP.NUMBER, EMPTY_STRING);
                  const number = inputValue ? Number(inputValue).toString() : EMPTY_STRING;

                  setValue(`discounts.${index}.rate`, number, { shouldValidate: true, shouldDirty: true });
                }}
                errorMessage={errors?.discounts?.[index]?.rate?.message}
              />
            )}
          />
        </Grid2>
      </Grid2>

      <Grid2 size='auto' className='flex justify-center items-center'>
        <IconButton className={cx('closeField')} onClick={() => onRemoveItem(index)}>
          <img src={icons.commonIconClose} alt={t('common_alt_img', { ns: 'common/base' })} />
        </IconButton>
      </Grid2>
    </Grid2>
  );
};

export default memo(DiscountJob);
